export default __webpack_public_path__ + "static/media/3170.aa0384bc.svg";